<template>
  <v-container fluid>
    <div v-if="loanApplication">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-img
            class="my-2"
            src="@/assets/Bradbury_logo_2022.jpg"
            max-height="100"
            contain
            position="center"
          ></v-img>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <span class="text-h7">PRE-AGREEMENT STATEMENT AND QUOTATION</span>
        </v-col>
        <v-col cols="6" class="text-center">
          <span class="text-caption"
            >These quotations are valid for 5 business days</span
          >
        </v-col>
      </v-row>
      <v-spacer class="pb-1"></v-spacer>
      <v-row>
        <v-col cols="12">
          <span class="text-h5">
            PART 1: THE CREDIT PROVIDER OFFERS THE FOLLOWING AVAILABLE LOANS:
          </span>
        </v-col>
      </v-row>
      <v-spacer class="pb-1"></v-spacer>
      <v-row>
        <v-col cols="12">
          <span class="text-caption">Maximum Repayment: ± 25% of Salary</span>
        </v-col>
      </v-row>
      <v-row class="pb-1">
        <v-col cols="12">
          <v-card style="background-color: red">
            <v-data-table
              :items="[loanApplication.loanType]"
              :headers="loanTypeHeaders"
              hide-default-footer
              no-data-text="No loan selected"
              class="grey lighten-4"
            >
              <template v-slot:[`item.randValue`]="{ item }">
                {{ "R" + item.randValue.toFixed(2) }}
              </template>
              <template v-slot:[`item.adminFee`]="{ item }">
                {{ "R" + item.adminFee.toFixed(2) }}
              </template>
              <template v-slot:[`item.totalInterest`]="{ item }">
                {{ "R" + item.totalInterest.toFixed(2) }}
              </template>
              <template v-slot:[`item.creditLifeFee`]="{ item }">
                {{ "R" + item.creditLifeFee.toFixed(2) }}
              </template>
              <template v-slot:[`item.serviceCharge`]="{ item }">
                {{ "R" + item.serviceCharge.toFixed(2) }}
              </template>
              <template v-slot:[`item.payment`]="{ item }">
                {{ "R" + item.payment.toFixed(2) }}
              </template>
              <template v-slot:[`item.totalPayment`]="{ item }">
                {{ "R" + item.totalPayment.toFixed(2) }}
              </template></v-data-table
            >
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="loanApplication.repaymentDate">
        <v-col cols="12">
          <span class="text-h6"
            >Chosen repayment date: {{ loanApplication.repaymentDate }}</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="text-p">
            The Company agrees: To deduct the number of repayments from the
            Applicant's salary monthly & pay same over to the Credit Provider or
            its nominee. In the event of the employee leaving the Company, the
            outstanding loan balance becomes immediately due. <br />The Employee
            hereby authorises the Company to deduct the agreed monthly
            instalment from their salary each month until the full loan amount,
            including any applicable fees and interest, has been repaid. The
            Employee hereby authorises the Employer to deduct from any
            remuneration due to them, including but not limited to bonuses,
            overtime, leave pay, and/or any other accrued benefits, any amounts
            owing under this loan agreement until the debt is fully settled. If,
            further to this, there is still an outstanding balance, we hereby
            acknowledge Bradbury Finance will process the deduction via debit
            order on my bank account nominated.
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <span class="text-h5">PART 2: EMPLOYER / COMPANY:</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex flex-column">
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="loanApplication.company.name"
                label="Company:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="loanApplication.company.pastelCode"
                label="Company Code:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="loanApplication.company.region"
                label="Region:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="loanApplication.company.branch"
                label="Branch:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <span class="text-h7">MONTHLY SHORT TERM CREDIT TRANSACTION</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <span class="text-h5"
            >PART 3: The Applicant / Consumer / Employee</span
          >
        </v-col>
        <v-col cols="6">
          <span class="text-caption">
            The Applicant / Consumer / Employee hereafter referred to as the
            Applicant
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" class="d-flex flex-column">
          <v-row>
            <v-col cols="12">
              <span class="text-p">The Applicant:</span>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.employee.name"
                :error="!loanApplication.employee.name"
                label="FIRST NAMES:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.employee.surname"
                :error="!loanApplication.employee.surname"
                label="SURNAME:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.employee.title"
                :error="!loanApplication.employee.title"
                label="TITLE:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.employee.idNumber"
                :error="!loanApplication.employee.idNumber"
                label="ID/Passport Number:"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.employee.cell"
                :error="!loanApplication.employee.cell"
                label="CONTACT TELL No.:"
                type="number"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.employee.address"
                :error="!loanApplication.employee.address"
                label="ADDRESS:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.employee.email"
                :error="!loanApplication.employee.email"
                label="EMAIL:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.employeeClockNumber"
                :error="!loanApplication.employeeClockNumber"
                label="PERSONNEL / CLOCK NUMBER:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" class="d-flex flex-column">
          <v-row>
            <v-col cols="12">
              <span class="text-p">The Applicant's Spouse:</span>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseName"
                :error="!loanApplication.spouseName"
                label="FIRST NAMES:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseSurname"
                :error="!loanApplication.spouseSurname"
                label="SURNAME:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseTitle"
                :error="!loanApplication.spouseTitle"
                label="TITLE:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseIdNumber"
                :error="!loanApplication.spouseIdNumber"
                label="ID/Passport Number:"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseCell"
                :error="!loanApplication.spouseCell"
                label="CONTACT TELL No.:"
                type="number"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseAddress"
                :error="!loanApplication.spouseAddress"
                label="ADDRESS:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.spouseEmail"
                :error="!loanApplication.spouseEmail"
                label="EMAIL:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-btn
            :dark="doesPayslipsExist"
            :class="screenWidth > 659 ? 'mr-2 mb-2' : 'mb-2'"
            color="green"
            :disabled="!doesPayslipsExist"
            @click="downloadPayslip()"
            >Download Payslip(s)</v-btn
          >
          <v-btn
            :dark="doesIdExist"
            color="green"
            class="mb-2"
            :disabled="!doesIdExist"
            @click="downloadId()"
            >Download Identification/Passport</v-btn
          >
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col
          cols="12"
          :sm="proofOfBankImage ? '6' : '12'"
          :class="proofOfBankImage && screenWidth >= 600 ? 'pr-2' : ''"
        >
          <v-row v-if="signatureImage" no-gutters>
            <v-col cols="12">
              <span class="text-h6">Signature:</span>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="signatureImage">
            <v-col cols="12">
              <img
                :src="this.signatureImage"
                style="
                  max-height: 600px;
                  max-width: -webkit-fill-available;
                  border-style: solid;
                  border-width: 1px;
                  border-radius: 4px;
                  border-color: darkgrey;
                "
              />
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-4">
            <v-btn
              :dark="doesSignatureImageExist"
              :class="screenWidth > 595 ? 'mr-2 mb-2' : 'mb-2'"
              color="green"
              :disabled="!doesSignatureImageExist"
              @click="downloadSignatureImage()"
              >Download Signature</v-btn
            >
            <v-btn
              v-if="!proofOfBankImage"
              :dark="doesProofOfBankExist"
              color="green"
              :disabled="!doesProofOfBankExist"
              @click="downloadProofOfBank()"
              >Download Proof of Banking</v-btn
            >
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" v-if="proofOfBankImage">
          <v-row no-gutters>
            <v-col cols="12">
              <span class="text-h6">Proof of Banking Account:</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <img
                :src="this.proofOfBankImage"
                style="
                  max-height: 600px;
                  max-width: -webkit-fill-available;
                  border-style: solid;
                  border-width: 1px;
                  border-radius: 4px;
                  border-color: darkgrey;
                "
              />
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-4">
            <v-col cols="12">
              <v-btn
                :dark="doesProofOfBankExist"
                class="mr-2"
                color="green"
                :disabled="!doesProofOfBankExist"
                @click="downloadProofOfBank()"
                >Download Proof of Banking</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-checkbox
          v-model="loanApplication.consent"
          :class="
            screenWidth < 447
              ? 'mb-15'
              : screenWidth < 565
              ? 'mb-10'
              : screenWidth < 756
              ? 'mb-5'
              : ''
          "
          :error="!loanApplication.consent"
          label="I hereby give consent that, at my request, Bradbury Finance Pty Ltd may
        forward my necessary details to another service provider in the event
        they cannot assist me."
          readonly
        >
        </v-checkbox>
      </v-row>
      <v-row>
        <v-col cols="6">
          <span class="text-h5">PART 4: BANK DETAILS OF APPLICANT</span>
        </v-col>
        <v-col cols="6">
          <span class="red--text text-caption">
            (This information is very important for payment into Applicant's
            account)
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex flex-column">
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="loanApplication.bankName"
                :error="!loanApplication.bankName"
                label="NAME OF BANK:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="loanApplication.branchName"
                :error="!loanApplication.branchName"
                label="BRANCH NAME:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="loanApplication.branchNumber"
                :error="!loanApplication.branchNumber"
                label="BRANCH No.:"
                type="number"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="loanApplication.accountNumber"
                :error="!loanApplication.accountNumber"
                label="ACCOUNT No.:"
                type="number"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="loanApplication.accountName"
                :error="!loanApplication.accountName"
                label="ACCOUNT NAME:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <span class="text-h7"
            >PLEASE COMPLETE THE FOLLOWING INFORMATION:</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" class="d-flex flex-column">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.grossSalary"
                :error="!loanApplication.grossSalary"
                label="GROSS SALARY:"
                type="number"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.nettSalary"
                :error="!loanApplication.nettSalary"
                label="NETT SALARY:"
                type="number"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-data-table
                  :items="loanApplication.expenses"
                  :headers="expenseHeaders"
                  hide-default-footer
                  :items-per-page="20"
                  no-data-text="No expenses added yet"
                  class="grey lighten-4"
                ></v-data-table>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.totalLeft"
                :error="!loanApplication.totalLeft"
                label="TOTAL LEFT:"
                type="number"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" class="d-flex flex-column">
          <v-row>
            <v-col cols="12">
              <v-switch
                v-model="loanApplication.underAdministration"
                :label="`ARE YOU UNDER ADMINISTRATION ?`"
                readonly
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="loanApplication.isThisEmergencyLoan"
                :label="`IS THIS AN EMERGENCY LOAN ?`"
                readonly
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="loanApplication.underDeptReview"
                :label="`ARE YOU UNDER DEBT REVIEW ?`"
                readonly
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="loanApplication.loanPurpose"
                :error="!loanApplication.loanPurpose"
                :items="Object.keys(loanPurposes)"
                return-object
                label="WHAT IS THE PURPOSE OF THE LOAN ?"
                readonly
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="loanApplication.loanPurposeOther"
                :error="!loanApplication.loanPurposeOther"
                label="OTHER LOAN PURPOSE:"
                type="string"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="pb-1">
        <v-col cols="12">
          <span class="text-p">
            I agree that the Credit Provider may request and obtain any
            financial information about me on record from the National Credit
            Register and Credit Bureau.
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <span class="text-h5">PART 5: AGREEMENT</span>
        </v-col>
        <v-col cols="6">
          <span class="text-caption"
            >which includes Debit order authorization DEBICHECK</span
          >
        </v-col>
      </v-row>
      <v-row class="pb-5">
        <v-col cols="12">
          <span class="text-p">
            The Borrower herewith applies in the language of his / her choice.
            The Borrower herewith applies for the above selected loan and
            authorizes herewith irrevocably the Employer to deduct the amount
            and number of monthly repayments from his /her salary until the loan
            has been settled. The Borrower accepts that the Credit Provider may
            request & obtain any financial information about the Borrower on
            record from the National Credit Register & Credit Bureau & accepts
            that this loan will be listed on Credit Bureau. The Borrower hereby
            agrees that in the event of him/her leaving and there is an
            outstanding amount due on the loan, Bradbury Finance has the
            Borrower’s authorization to debit the Borrower’s bank account with
            the outstanding due. The Credit Provider shall consider the
            application and if approved, pay the amount of the loan directly
            into the Borrower’s designated bank account. The Employer of the
            Borrower undertakes to deduct the monthly repayment from the
            Borrower’s salary & pay same over to the Credit Provider's nominated
            account at the end of every month. In the event of the Borrower’s
            employment being terminated, for whatever reason, the Borrower
            hereby authorizes Credit Provider to issue and deliver debit order
            payment instructions to the Borrower’s banker for collection against
            my above-mentioned account and Bank indicated above on condition
            that the sum of each payment instruction and frequency of payment
            requests will never exceed the obligations as agreed and defined in
            the Agreement specified. The Borrower can only service the
            obligations defined in here if the payment instructions are executed
            as close as possible to when I receive my salary or wages which
            dates vary from month to month, especially during December of each
            year. To curb against (1) unpaid bank charges (2) losing the
            benefits described in the agreement quoted (3) incurring penalties
            due to non-payment; the Borrower explicitly authorize Credit
            Provider to utilize the functionality of Tracing supported on the
            DEBICHECK Payment Stream. Tracking supported on the DEBICHECK
            Payment Stream has been explained to me and I acknowledge that my
            above-mentioned account will be interrogated for a defined period
            until this period has lapsed or until payment was received. The
            Borrower hereby agree that in instances of an unpaid item, Credit
            Provider may submit the arrear payment together with a further due
            payment in any payment cycle or frequency as indicated above. The
            Borrower hereby agrees that subsequent payment instructions will
            continue to be delivered in terms of this authority until all
            obligations have been paid. This authorization will remain in force
            until cancelled by me in writing. The Borrower hereby acknowledges
            that my bank will charge fees to my account as agreed with them once
            they process this instruction. In terms of section 40(1) of the
            National Credit Act 34 of 2005 read with the threshold prescribed in
            terms of section 42(1) of the Act, registration as a credit provider
            is required if the total principal debt owed to the credit provider
            (or any associated person) in terms of all current credit agreements
            (other than incidental credit agreements) exceeds R500 000. The
            Borrower must pay interest at the rate declared on the first page of
            this contract. The interest must be paid together with the repayment
            of the capital sum of the loan at the conclusion of the loan period.
            The Borrower expressly renounces the benefits of the exceptio non
            numeratae pecuniae (the defence that the money has not been paid)
            and confirms that he/she understands the meaning of this exception
            and the effect of its renunciation. If repayment is made by way of
            monthly instalments, all payments must be made by the Borrower on or
            before the third business day of every month at (address at which
            payment must be made) or such other address as the lender may at a
            later stage advise in writing. If the Borrower fails to pay any
            instalment on the due date, the Credit Provider can immediately
            claim the full balance of the loan together with interest up to the
            date of payment. No relaxation by the lender in enforcing the
            acceleration clause at any stage will amount to a waiver of the
            lender's rights in terms of that clause. The Borrower can pay larger
            instalments than prescribed, or can pay the full balance of capital
            and interest at any time prior before the prescribed dates for
            payment. In that event, interest will be calculated only up to the
            date of payment. The Borrower may settle this agreement at any time
            in terms of section 125 of the National Credit Act 34 of 2005 by
            paying the unpaid balance of the loan amount, unpaid interest
            charges and all other fees and charges up to the date of settlement.
            If the Borrower does not make payment of any instalment on the due
            date for the payment of that instalment and the Credit Provider
            decides to enforce the acceleration clause, the lender must first
            give written notice to the borrower calling upon him or her to make
            payment within (insert number) days, failing which the lender will
            immediately thereafter be entitled to claim payment of whatever is
            due in terms of this agreement. In terms of Section 123 of the
            National Credit Act 34 of 2005, the lender reserves the right to
            terminate (cancel) this loan agreement with the Borrower if the
            Borrower defaults in making payment of any of the agreed repayments
            due in terms of this agreement, and the lender may thereafter
            proceed in terms of Section 129(1)(b) and Section 130 of the
            National Credit Act, which may result in a court of law enforcing
            the repayment of the borrower's outstanding obligations in terms of
            this agreement and in the judgment of the court being recorded by
            credit bureau. In the event of a breach by the Borrower of this
            agreement, the Borrower consents to the grant by a court of
            competent jurisdiction of an emoluments attachment order in respect
            of the amount of the judgment debt pursuant to the provisions of the
            Magistrates' Courts Act 32 of 1944 governing such orders. 22. The
            full balance of the capital and interest shall become payable
            immediately upon sequestration of the Borrower's estate. The parties
            confirm that this contract contains the full terms of their
            agreement and that no addition to or variation of this contract will
            be of any force or effect unless reduced to writing and signed by
            both parties. The parties choose as their respective domicilia
            citandi et executandi. I hereby authorise Bradbury Finance Pty Ltd
            to issue and deliver debit order payment instructions to your banker
            for collection against my Account and Bank used by my employer to
            deposit my salaries/wages, which account may differ from the account
            specified above on condition that the sum of each payment
            instruction and frequency of payment requests will never exceed the
            obligations as agreed and defined in the Agreement specified. My
            bank’s participation in the relevant payment stream, the
            authentication mechanism used by me, and the relevant rules
            applicable to the payment streams will determine per repayment cycle
            the most suitable payment stream in order to fulfil the obligations
            as defined in the agreement. My authorisation is subject thereto
            that the same payment instruction may never be presented
            simultaneously in more than one payment stream during the same
            repayment cycle or, if unpaid in a payment stream selected to be
            represented in the same cycle in another payment stream. I can only
            service the obligations defined in here if the payment instructions
            are executed as close as possible to when I receive my salary or
            wages which dates vary from month to month, especially during
            December of each year. To curb against (1) unpaid bank charges (2)
            losing the benefits described in the agreement quoted (3) incurring
            penalties due to non-payment; I explicitly authorise Bradbury
            Finance Pty Ltd to utilise the functionality of Tracking supported
            on the Authenticated and EDO Payment Streams especially after
            unsuccessful attempts on the EFT Payment Stream. Tracking supported
            on the Authenticated and EDO Payment Streams has been explained to
            me and I acknowledge that my above-mentioned account will be
            interrogated for a defined period until this period has lapsed or
            until payment has been received. I hereby agree that subsequent
            payment instructions will continue to be delivered in terms of the
            authority until all obligations have been paid. This authorisation
            will remain in force until cancelled by me in writing. I hereby
            acknowledge that my bank will charge fees to my account as agreed
            with them once they process this instruction. I foresee that I may
            change my bank and bank account particulars reflected in here, in
            which instance I will notify the beneficiaries specified, or any new
            beneficiary, should the agreement be ceded or assigned to any third
            party. Should I however forget to notify the beneficiary or the
            assigned third party and if the beneficiary or the assigned third
            party obtain my new bank particulars, on my account, this mandate
            will not lapse. This issued mandate will cover the obtained bank
            information and the beneficiary and the assigned third party may
            attach such new information, to this signed document as annexure,
            and the attached annexure must be read together with this mandate,
            by my new bank.
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="text-center text-h5">SCHEDULE</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="red--text text-h7">STANDARD TERMS AND CONDITIONS</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="text-p">
            1. The Consumer / Applicant declares that by making the monthly
            repayment of this agreement, he/ she will still be able to satisfy
            in a timely manner all his /her other obligations under other credit
            agreements. 2. The above listed addresses of the Consumer /
            Applicant and Credit Provider will prevail where documents and legal
            process will be accepted. A change of address will be notified in
            writing to the other party by delivering same by fax, email,
            registered mail or by hand. 3. The Consumer / Applicant will recieve
            monthly statements of account at the address of his / her Employer.
            4. The Applicant may terminate this agreement at any time by paying
            the settlement amount comprising of the balance of the amount of the
            loan and the outstanding amount of interest and administration fee
            as at the date of settlement. 5. The Credit Provider may terminate
            the agreement if the Consumer / Applicant is in default. 6. Any
            amount in arrears due to the default of the Consumer / Applicant
            will attract interest at the same rate as the loan said above. 7.
            Any extension of time or indulgences granted by the Credit provider,
            shall not constitute a waiver of its rights under this agreement. 8.
            Every term in this agreement is divisible from the other. Should any
            term be unenforceable, void or voidable, the validity of the rest of
            the agreement shall not be affected. 9. The above comprises the
            entire agreement between the parties and any change thereof in
            whatsoever manner shall be in writing and signed by the concerned
            parties. 10. Should the Applicant default on any payment, Bradbury
            Finance (Pty) Ltd, shall have the right without prejudice to any of
            its other rights to give the Applicant notice to rectify such
            breach; act of insolvency, etc. within twenty (20) working days ,
            and if not so rectified within such notice period elect to: • Treat
            as immediately due and payable all outstanding amounts currently due
            and payable; • Cancel the agreement and apply for an order at the
            appropriate court claiming all outstanding amounts as well as all
            legal fees on an Attorney Client Basis;” 11. The Applicant shall be
            liable for all costs by Bradbury Finance (Pty) Ltd in recovery of
            any amounts or the enforcement of any rights which it has hereunder,
            including collection charges and costs on an attorney and client
            scale and costs of counsel as on brief incurred during the
            institution of legal proceedings if judgement has been granted, in
            connection with the satisfaction or enforcement of such judgement by
            an appropriate court. This is subject to the jurisdiction of the
            relevant court or tribunal where the case will be adjudicated whom
            in their final discretion will determine the amount of costs for
            which the Applicant will be held liable. 12. The Applicant hereby
            consents to the Jurisdiction of the Magistrate’s Court having
            jurisdiction over its person in respect of proceedings arising from
            this agreement, even if e amount in issue would otherwise exceed the
            Jurisdiction of this court. 13. The Applicant acknowledges the risk
            involved in borrowing money from Bradbury Finance (Pty) Ltd and
            hereby indemnifies Bradbury Finance (Pty) Ltd against losses the
            Applicant might sustain with regards to the granting by Bradbury
            Finance (Pty) Ltd, due to reasons beyond the control of the credit
            provider. This will include any of the loan economical lost
            pertaining to the harm/losses caused. Compulsory Disclosures and
            Permitted Exclusions WHAT IS COVERED? - Death / permanent disability
            - outstanding balance of your loan - Temporary disability - your
            obligations that become due and payable until the end of the term of
            your loan, or until you are no longer disabled , whichever is
            shorter - Permanent Disability - your obligations become due and
            payable until the end of the term of your loan. The benefit will
            only be payable after six months of continues dyability, according
            to the insurers disability definition. - Unemployment / loss of
            income - your obligations that become due and payable until the end
            of the term of your loan, or until you find employment, or earn an
            income. Maximum 12 months. All benefits ceases on the last day of
            the month in which you reach the age of 65 years. WHAT IS EXCLUDED?
            DEATH AND DISABILITY Abuse of alcohol or narcotics; Suicide or
            self-inflicted injuries; Active participation in war or riots; Use
            of nuclear, chemical weapons or any radioactive contaminations;
            Participation in criminal activities; Participation in hazardous
            activities i.e. mountain climbing / bungee jumping / speed racing;
            Any pre-exisiting conditions that you were aware of that affected
            you in the 12 months preceding the commencement of this cover. The
            disability benefits will not apply to Insured lives, should the date
            of commencement of disability occur within twelve months of the
            entry date and the disability directly or indirectly arises from, or
            is traceable to (a) A bodily injury which occurred, or (b) Diseased
            condition of which the member was aware or experienced symptoms or
            for which the member received medical treatment, during the six
            months immediately prior to entry date. UNEMPLOYMENT OR INABILITY TO
            EARN AN INCOME A waiting period of 3 months will apply during which
            there is no cover or benefit. Retrenchment or termination within the
            first 3 months of commencement of the credit life insurance; Lawful
            dismissal; Voluntary forfeiture of salary; Voluntary retrenchment;
            Resignation; Retirement; Participating in an unprotected strike; or
            Retrenchment of which you were aware of or received notice of during
            the three months preceding date of credit life insurance, are all
            excluded. YOUR RIGHT TO CHOOSE The National Credit Act requires that
            Credit Life Insurance being offered to you as part of the loan
            offer. You may select to not take the credit life insurance, in
            which case you must do so in writing to your Employer and / or
            Union. In this event your Employer and / or Union may insist that
            you provide satisfactory proof of other cover for your obligations
            in terms of the loan that you are applying for. TERMS AND CONDITIONS
            APPLY WHICH CAN BE OBTAINED FROM BRADBURY FINANCE PTY LTD
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="text-center text-h5">
            COMPULSORY DISCLOSURES AND PERMITTED EXCLUSIONS
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="text-h6">WHAT IS COVERED?</span>
        </v-col>
      </v-row>
      <v-col class="mb-3">
        <ul>
          <li>
            Death / permanent disability - outstanding balance of your loan.
          </li>
          <li>
            Temporary disability - your obligations that become due and payable
            until the end of the term of your loan, or until you are no longer
            disabled , whichever is shorter.
          </li>
          <li>
            Permanent Disability - your obligations become due and payable until
            the end of the term of your loan. The benefit will only be payable
            after six months of continues dyability, according to the insurers
            disability definition.
          </li>
          <li>
            Unemployment / loss of income - your obligations that become due and
            payable until the end of the term of your loan, or until you find
            employment, or earn an income.
          </li>
          <li>Maximum 12 months.</li>
        </ul>
      </v-col>
      <v-row>
        <v-col>
          <span class="text-h7 font-weight-bold"
            >All benefits ceases on the last day of the month in which you reach
            the age of 65 years.</span
          >
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col>
          <span class="text-h6">WHAT IS EXCLUDED?</span>
        </v-col>
      </v-row>
      <v-col>
        <v-row>
          <span class="text-p">DEATH AND DISABILITY</span>
        </v-row>
        <v-row class="mb-5">
          <span class="text-p"
            >Abuse of alcohol or narcotics; Suicide or self-inflicted injuries;
            Active participation in war or riots; Use of nuclear, chemical
            weapons or any radioactive contaminations; Participation in criminal
            activities; Participation in hazardous activities i.e. mountain
            climbing / bungee jumping / speed racing; Any pre-exisiting
            conditions that you were aware of that affected you in the 12 months
            preceding the commencement of this cover The disability benefits
            will not apply to Insured lives, should the date of commencement of
            disability occur within twelve months of the entry date and the
            disability directly or indirectly arises from, or is traceable to
            (a) A bodily injury which occurred, or (b) Diseased condition of
            which the member was aware or experienced symptoms or for which the
            member received medical treatment, during the six months immediately
            prior to entry date.</span
          >
        </v-row>
        <v-row>
          <span class="text-p"
            >UNEMPLOYMENT OR INABILITY TO EARN AN INCOME</span
          >
        </v-row>
        <v-row class="mb-5">
          <span class="text-p"
            >A waiting period of 3 months will apply during which there is no
            cover or benefit. Retrenchment or termination within the first 3
            months of commencement of the credit life insurance; Lawful
            dismissal; Voluntary forfeiture of salary; Voluntary retrenchment;
            Resignation; Retirement; Participating in an unprotected strike; or
            Retrenchment of which you were aware of or received notice of during
            the three months preceding date of credit life insurance, are all
            excluded.</span
          >
        </v-row>
        <v-row>
          <span class="text-p">YOUR RIGHT TO CHOOSE</span>
        </v-row>
        <v-row class="mb-5">
          <span class="text-p"
            >The National Credit Act requires that Credit Life Insurance being
            offered to you as part of the loan offer. You may select to not take
            the credit life insurance, in which case you must do so in writing
            to your Employer and / or Union. In this event your Employer and /
            or Union may insist that you provide satisfactory proof of other
            cover for your obligations in terms of the loan that you are
            applying for.</span
          >
        </v-row>
        <v-row class="mb-5">
          <span class="text-p"
            >TERMS AND CONDITIONS APPLY WHICH CAN BE OBTAINED FROM BRADBURY
            FINANCE PTY LTD</span
          >
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <span class="text-h6">Full Name:</span>
        </v-row>
        <v-row>
          <v-text-field
            id="FullNameTextField"
            v-model="loanApplication.fullName"
            type="string"
            readonly
          ></v-text-field>
        </v-row>
      </v-col>
    </div>
  </v-container>
</template>

<script>
import { LoanPurposes, Expenses } from "@/models";
import { Storage } from "@aws-amplify/storage";
import _ from "lodash";

export default {
  name: "ViewSingleApplication",

  props: {
    application: {},
  },

  async mounted() {
    this.loanApplication = _.cloneDeep(this.application);
    this.loanApplication.expenses = JSON.parse(this.loanApplication.expenses);
    if (
      this.loanApplication.signatureImage &&
      !this.loanApplication.signatureImage.includes(".pdf")
    ) {
      this.signatureImage = await Storage.get(
        this.loanApplication.signatureImage,
        {
          level: "public",
        }
      );
    }
    if (
      this.loanApplication.proofOfBank &&
      !this.loanApplication.proofOfBank.includes(".pdf")
    ) {
      this.proofOfBankImage = await Storage.get(
        this.loanApplication.proofOfBank,
        {
          level: "public",
        }
      );
    }

    this.loanTypeHeaders = [
      {
        text: "Loan Amount",
        value: "randValue",
        class: "grey lighten-2",
      },
      {
        text: "Term",
        value: "periodNumber",
      },
      {
        text: "Initial fee once off",
        value: "adminFee",
        class: "grey lighten-2",
      },
      {
        text: "Interest",
        value: "totalInterest",
      },
      {
        text: "Credit life per month",
        value: "creditLifeFee",
        class: "grey lighten-2",
      },
      {
        text: "Service fee per month",
        value: "serviceCharge",
      },
      {
        text: `Payment per ${this.getHeaderPeriod()}`,
        value: "payment",
        class: "grey lighten-2",
      },
      {
        text: "Total Payment",
        value: "totalPayment",
      },
      {
        text: "For office use",
        value: "code",
        class: "grey lighten-2",
      },
    ];
  },
  components: {},

  data: () => ({
    loanTypeHeaders: [],
    expenseHeaders: [
      { text: "Expense", value: "type", class: "grey lighten-2" },
      { text: "Amount", value: "amount" },
    ],
    signatureImage: null,
    proofOfBankImage: null,
    valid: false,
    loanPurposes: LoanPurposes,
    expenses: Expenses,
    newEmployee: {},
    modelEmployee: {},
    loanApplication: null,
  }),
  methods: {
    getHeaderPeriod() {
      const salaryFrequency = this.loanApplication.salaryFrequency;
      if (salaryFrequency === "Monthly") {
        return "Month";
      } else if (salaryFrequency === "Weekly") {
        return "Week";
      } else if (salaryFrequency === "Fortnightly") {
        return "Fortnight";
      }
    },
    async downloadId() {
      try {
        const downloadedId = await Storage.get(
          this.loanApplication.identification,
          {
            level: "public",
          }
        );
        window.open(downloadedId);
      } catch (error) {
        console.log(error);
      }
    },
    async downloadProofOfBank() {
      try {
        const downloadedProofOfBank = await Storage.get(
          this.loanApplication.proofOfBank,
          {
            level: "public",
          }
        );
        window.open(downloadedProofOfBank);
      } catch (error) {
        console.log(error);
      }
    },
    async downloadSignatureImage() {
      try {
        const downloadedSignatureImage = await Storage.get(
          this.loanApplication.signatureImage,
          {
            level: "public",
          }
        );
        window.open(downloadedSignatureImage);
      } catch (error) {
        console.log(error);
      }
    },
    async downloadPayslip() {
      try {
        for (let i in this.loanApplication.payslips) {
          const downloadedPayslip = await Storage.get(
            this.loanApplication.payslips[i],
            {
              level: "public",
            }
          );
          window.open(downloadedPayslip);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    screenWidth() {
      let width = this.$vuetify.breakpoint.width;
      return width;
    },
    doesIdExist() {
      if (this.loanApplication.identification) {
        return true;
      } else {
        return false;
      }
    },
    doesPayslipsExist() {
      if (this.loanApplication.payslips) {
        return true;
      } else {
        return false;
      }
    },
    doesProofOfBankExist() {
      if (this.loanApplication.proofOfBank) {
        return true;
      } else {
        return false;
      }
    },
    doesSignatureImageExist() {
      if (this.loanApplication.signatureImage) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
